import { CouponService } from './../../../services/coupon.service';
import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';

import { LoaderService } from './../../../services/loader.service';
import browser from 'browser-detect';
import { AppSetting } from '../../../global/appsetting';
import { ProductsService } from '../../../services/products.service';
import { ServerConfigService } from '../../../services/server-config.service';
import { HeaderService } from '../../../services/header.service';
import { GaAnalyticsService, EVENT_TYPES } from 'src/app/services/ga-analytics.service';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { TransactionsService } from 'src/app/services/transactions.service';
import { takeWhile } from 'rxjs';


@Component({
  selector: 'app-online-header',
  templateUrl: './online-header.component.html',
  styleUrls: ['./online-header.component.scss']
})
export class OnlineHeaderComponent implements OnInit, OnChanges, OnDestroy {

  menuItems = [
    { id: 0, title: 'מי אנחנו', link: '/archonline_about', menuIndex: 1 },
    { id: 1, title: 'הזמנת תוכנית', link: '/archonline_product_list' },
    { id: 2, title: 'איך זה עובד', link: '/archonline_how_it_works', menuIndex: 2 },
    { id: 3, title: 'צור קשר', link: '/archonline_ask_us', menuIndex: 3 },
    { id: 4, title: 'טיפים לעיצוב', link: '/aoc/archonline_article_list' }
  ];
  @Input() title: string;
  @Input() step: string;
  faFacebookSquare = faFacebookSquare;
  faInstagram = faInstagram;
  conactPhone = '';
  displayOverLoad;
  activeStages = [true, false, false];
  trnsItems: any;
  overloadConfig: any;
  scrollHeight = this.headerService.scrollHeight;
  lastScrollPos = 0;
  headerBckActive = false;
  timeToCheckVersionUpdate = 3600000; //one hour
  private _isComponentActive = true;

  constructor(
    public loaderService: LoaderService,
    public appsetting: AppSetting,
    private serverConfigService: ServerConfigService,
    public productsService: ProductsService,
    public headerService: HeaderService,
    public couponService: CouponService,
    private gaAnalyticsService: GaAnalyticsService,
    public transactionsService: TransactionsService
  ) {

    setTimeout(() => {
      this.headerService.isInAMiddleOfScroll.value = true;
      setTimeout(() => {
        this.headerService.isInAMiddleOfScroll.value = false;
      }, 3000);
      this.headerService.checkTab(true);
    }, 0);
    let timer; 
    let startScroll = true;
     window.onscroll = (e) => {
       if(startScroll){
         this.windowScroll(e);
         startScroll = false;
       }
      clearTimeout(timer);
      timer = setTimeout( ()=>{
        startScroll = true;
        this.windowScroll(e);
      }, 150 );
       
     }

     

    this.conactPhone = this.appsetting.phone;
    this.transactionsService.clientTransactionsView$.pipe(takeWhile(()=>this._isComponentActive)).subscribe(transactions=>{
      this.trnsItems = transactions;
    })
    this.checkUpdateVersion();
  }
  
  checkUpdateVersion() {
    let lastTimeUpdateVersion: Date;
    if (localStorage.lastTimeUpdateVersion) {
      lastTimeUpdateVersion = new Date(localStorage.lastTimeUpdateVersion);
    }

    if (lastTimeUpdateVersion) {
      let now = new Date();
      if (now.getTime() - lastTimeUpdateVersion.getTime() > this.timeToCheckVersionUpdate) {
        this.serverConfigService.GetConfigByKey('version').toPromise().then((res: any) => {
          if (localStorage.websiteversion && localStorage.websiteversion != res.SValue) {
            window.location.reload();
          }
          localStorage.websiteversion = res.SValue;
          localStorage.lastTimeUpdateVersion = new Date();
        }).catch(err=>{
          this.gaAnalyticsService.logEventToGa('checkUpdateVersion', 'OnlineHeaderComponent', EVENT_TYPES.Error);
        })
      }
    }
  }
  clickLogo() {
    window.localStorage.setItem('routFromOtherPage', '0');
    window.scrollTo(0, 0);
    this.appsetting.scrollY = 0;
    this.headerService.changeTab(-1);
  }

  windowScroll(e) {
    this.headerService.justArrivedPage = false;
    this.headerService.isInAMiddleOfScroll.value = true;
    setTimeout(() => {
      this.headerService.isInAMiddleOfScroll.value = false;
      this.whatTabShouldBeActive();
    }, 1000);
    this.appsetting.scrollY = window.scrollY;
    if (window.scrollY > 0) {
      if (window.localStorage.getItem('routFromOtherPage') === '0') {
        this.headerBckActive = true;
      }

      document.querySelector('.online-content-cube-wrapper')?.classList.add('body-scroll');
      document.querySelector('.online-content-cube-wrapper')?.classList.remove('body-not-scroll');
      document.querySelector(".header-row-3")?.classList.add("header3-scroll");
      document.querySelector(".header-row-3")?.classList.remove("header3-not-scroll");
      document.querySelector('.online-qoute')?.classList.add('online-qoute-scroll');
    } else if (this.headerService.scrollHeight.value > 0) {
      document.querySelector('.online-content-cube-wrapper')?.classList.remove('body-scroll');
      document.querySelector('.online-content-cube-wrapper')?.classList.add('body-not-scroll');
      document.querySelector(".header-row-3")?.classList.remove("header3-scroll");
      document.querySelector(".header-row-3")?.classList.add("header3-not-scroll");
      document.querySelector('.online-qoute')?.classList.remove('online-qoute-scroll');
    }
    if (window.scrollY === 0) {
      this.headerBckActive = false;
      window.localStorage.routFromOtherPage = '0';
    }
    this.scrollHeight.value = window.scrollY;
  }
  
  whatTabShouldBeActive() {
    for (let i = 0; i < 4; i++) {
      const item = document.getElementById('menu-' + i);
      if (item) {
        if (this.headerService.isElementInViewport(item)) {
          if (i === 0) {
            this.headerService.currentTab = -1;
          } else {
            const currentItem = this.menuItems.find(x => x.menuIndex === i);
            this.headerService.currentTab = currentItem.id;
            this.headerService.changeUrlLocation(currentItem.link, currentItem.title);
          }
        }
      }
    }
  }

  ngOnInit() {
    this.checkBrowser();
    this.overloadConfig = this.serverConfigService.overloadConfigItem;
    this.displayOverLoad = this.serverConfigService.displayOverLoad;
    if ((<any>document.getElementById('first-loader'))) {
      (<any>document.getElementById('first-loader')).style = 'display: none';
    }

  }
  checkBrowser() {
    const result = browser();
    if (result.name === 'ie' || result.name === 'edge') {
      alert(`שים לב, אתר זה לא מתאים לגלישה בדפדפן אינטרנט אקספלורר.
      אנחנו ממליצים לך לעבור לדפדפן כרום או פיירפוקס לקבלת חוויית גלישה מלאה `);
    }
  }
  getRoutFromOtherPage() {
    return window.localStorage.getItem('routFromOtherPage');
  }
  closeOverload() {
    this.displayOverLoad.displayOverLoad = false;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.activeStages = [false, false, false];
      const currentStep = parseInt(changes.step.currentValue, 10);
      this.activeStages[currentStep] = true;
    }
  }
  backToStageOne() {
    (document.querySelector('#back-to-stage-1') as HTMLDivElement).click();
  }
  goToStageTwo() {
    (document.querySelector('#go-to-stage-2') as HTMLDivElement).click();
  }

  ngOnDestroy(){
    this._isComponentActive = false;
  }
}
